import { render } from "./RedefinirSenhaVie.vue?vue&type=template&id=057471dd"
import script from "./RedefinirSenhaVie.vue?vue&type=script&lang=js"
export * from "./RedefinirSenhaVie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__